<script>
import resources from './resources'
import '@desislavsd/vue-select/dist/vue-select.css'

export default {
  name: 'unit-form',
  mixins: [resources]
}
</script>

<template lang="pug">
  section.content
    .container-fluid
      loading(
        :active.sync='loading',
        :can-cancel='true',
        :is-full-page='fullPage',
        color='#7159c1'
      )
      .block-header
        .row
          .col-lg-5.col-md-5.col-sm-12
            h2 Unidades
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item
                a(href='javascript:void(0);') Unidades
              li.breadcrumb-item.active Cadastro
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(
                type='text',
                placeholder='Localizar Unidade',
                disabled
              )
              span.input-group-addon
                i.zmdi.zmdi-search

      .row.clearfix
        .col-lg-12.col-md-12.col-sm-12
          .card
            .header
              h2
              ul.header-dropdown
                li.dropdown(:class="{'show': show}")
                  a.dropdown-toggle(@click.prevent="showActions(show)", href='javascript:void(0);')
                    i.zmdi.zmdi-more
                  ul.dropdown-menu.dropdown-menu-right(:class="{'show': show}")
                    li
                      router-link(:to="{name: 'dweller.unit.index'}") Listagem
                    li
                      router-link(:to="{name: 'dweller.unit.create'}") Cadastro
            .body
                v-input(:status="$v.unit.tower_id.$error ? 'error' : null")
                  f-select(
                    name="tower_id",
                    v-model="unit.tower_id",
                    placeholder="Selecionar Torre"
                    :searchable="true",
                    :options="dwellerTowers",
                    label-by="label"
                    @selected="getTowerUnits"
                  )
                v-input(:status="$v.unit.unit_id.$error ? 'error' : null")
                  f-select(
                    name="unit_id",
                    v-model="unit.unit_id",
                    :searchable="true",
                    :multiple="false"
                    placeholder="Selecionar unidade"
                    :options="dwellerUnits",
                    label-by="label"
                  )
                .checkbox
                    input(
                      type='checkbox'
                      v-model="unit.available_for_rental"
                    )
                    label(for='terms', @click.prevent="availableForTental(!(!unit.available_for_rental))")
                      | Disponível para Locação
                button.btn.btn-raised.btn-primary.btn-round.waves-effect(
                  type='button',
                  @click.prevent="doSave()",
                ) Salvar
</template>
<style scoped>
.color-red {
  color: #f96332;
}
</style>



// WEBPACK FOOTER //
// src/app/tenant/unit/form/form.vue